/**
 * FleetManager V3 - Fleet Status Widget
 * Visual fleet status overview - clickable to navigate to vehicles
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Car, ChevronRight } from 'lucide-react';
import { Card, CardHeader, CardTitle } from '../../shared/index.js';

export function FleetStatusWidget({ data = {}, onNavigate }) {
  const { t } = useTranslation();
  const {
    total = 0,
    active = 0,
    maintenance = 0,
    outOfService = 0
  } = data;

  const segments = [
    { label: t('dashboard.fleet.active'), value: active, color: 'bg-emerald-500', percent: total > 0 ? (active / total) * 100 : 0 },
    { label: t('dashboard.fleet.maintenance'), value: maintenance, color: 'bg-amber-500', percent: total > 0 ? (maintenance / total) * 100 : 0 },
    { label: t('dashboard.fleet.outOfService'), value: outOfService, color: 'bg-red-500', percent: total > 0 ? (outOfService / total) * 100 : 0 }
  ];

  const handleClick = () => {
    onNavigate?.('vehicles');
  };

  return (
    <Card
      className="cursor-pointer hover:ring-1 hover:ring-blue-500/50 transition-all"
      onClick={handleClick}
    >
      <CardHeader>
        <CardTitle icon={Car} iconColor="text-blue-400">{t('dashboard.fleet.title')}</CardTitle>
        <div className="flex items-center gap-1">
          <span className="text-lg font-bold text-gray-900 dark:text-white">{total}</span>
          <ChevronRight size={14} className="text-gray-400 dark:text-slate-500" />
        </div>
      </CardHeader>

      {/* Progress bar */}
      <div className="h-2 bg-gray-200 dark:bg-slate-700 rounded-full flex overflow-hidden mb-3">
        {segments.map((seg, i) => (
          <div
            key={i}
            className={`${seg.color} transition-all`}
            style={{ width: `${seg.percent}%` }}
          />
        ))}
      </div>

      {/* Legend */}
      <div className="grid grid-cols-3 gap-2 text-center">
        {segments.map((seg, i) => (
          <div key={i}>
            <div className="flex items-center justify-center gap-1">
              <div className={`w-2 h-2 rounded-full ${seg.color}`} />
              <span className="font-semibold text-gray-900 dark:text-white text-sm">{seg.value}</span>
            </div>
            <span className="text-xs text-gray-500 dark:text-slate-400">{seg.label}</span>
          </div>
        ))}
      </div>
    </Card>
  );
}

export default FleetStatusWidget;
